import React, {useEffect, useState} from "react";
import Header from "../components/Header.js";
import * as AccountService from "../services/AccountService.js";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS, ORDER_PLACE} from "../util/Constants";
import * as StorageService from "../services/StorageService";
import CampaignCard from "../components/CampaignCard";
import {PATH} from "../routes/routes.js";
import analyticsLogEvent from "../services/FirebaseService";
import {detectBrowser, getAllCampaigns} from "../util/common";
import {FormattedMessage} from "react-intl";
import {useLocation, useNavigate} from "react-router";


function Main() {
    const navigateTo = useNavigate();
    const visible = "visible";
    const hidden = "hidden";
    const hasBackButton = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true" ? true : false;
    const userTable = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TABLE) : null;
    let shopNameFromStorage = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME);
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();

    const refUrl = query.get('refUrl');
    const returningUrl = query.get('returningUrl');
    const isBarPickup = query.get('isBarPickup');
    const isTakeaway = query.get('isTakeaway');


    if (returningUrl) {
        const urlParams = new URLSearchParams(new URL(returningUrl).search);
        const tableFromQuery = urlParams.get("table");
        const shopFromQuery = urlParams.get("shop");
        if (shopFromQuery === shopNameFromStorage) {
            if (tableFromQuery !== null) {
                StorageService.setItem(LOCALSTORAGE_ITEMS.USER_TABLE, tableFromQuery);
            }else{
                StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TABLE);
            }
        }else{
            StorageService.removeItem(LOCALSTORAGE_ITEMS.USER_TABLE);
        }

    }


    const domain = window.location.origin;
    const [state, setState] = useState({
        currentStyle: hidden,
        allCampaigns: [],
        allLinkCampaigns: [],
        shopDetails: null,
        continueInBrowser: StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) ? (StorageService.getItem(LOCALSTORAGE_ITEMS.CONTINUE_IN_BROWSER) + "") === "true" : false
    });

    const openModal = () => {
        setState({
            ...state,
            currentStyle: visible
        })
    }
    const closeModal = () => {
        setState({
            ...state,
            currentStyle: hidden
        })
    }

    useEffect(() => {
        detectBrowser();
        StorageService.removeItem(LOCALSTORAGE_ITEMS.CURRENT_CART); // SAME AS ON MOBILE
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.RESTAURANT,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.RESTAURANT
        });
    }, []);


    useEffect(() => {
        getPageContent();
    }, []);

    const getPageContent = async () => {

        let shopDetails = null;
        if (StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME)) {

            await AccountService.configApp();
            shopDetails = JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS));
        } else {
            return;
        }

        if (refUrl === "zoniz-restaurant.com") {
            await getCampaignsAndShopInfo(shopDetails);
            //already visited the zoniz-restaurant/cities site
            StorageService.setItem(LOCALSTORAGE_ITEMS.USER_ACCEPTED_COOKIES, "true");
            StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "true");
        } else {
            const city = shopDetails?.data?.address;

            const isLocalHost = domain.includes("localhost");

            const rootDomainUrl = isLocalHost ? "http://localhost" : "https://www.zoniz-restaurant.com";

            let cityPath = '';
            if (city && city.toLowerCase().includes("cluj-napoca")) {
                cityPath = isLocalHost ? `/ro/cluj-napoca` :  `/cities/ro/cluj-napoca`;
            } else if (city && city.toLowerCase().includes("sibenik")) {
                cityPath = isLocalHost ? `/hr/sibenik` : `/cities/hr/sibenik`;
            } else {
                await getCampaignsAndShopInfo(shopDetails);
                return;
            }

            let fullUrl = `${rootDomainUrl}${cityPath}?shop=${encodeURIComponent(shopDetails.name)}`;
            if (userTable) {
                fullUrl += `&table=${encodeURIComponent(userTable)}`;
            }

            if (isBarPickup) {
                fullUrl += `&isBarPickup=true`;
            }

            if (isTakeaway) {
                fullUrl += `&isTakeaway=true`;
            }

            fullUrl += `&domain=${encodeURIComponent(domain)}`

            window.location.href = fullUrl;
        }

    }


    const filterRestaurantLinkCampaigns = (allCampaigns) => {
        const filteredCampaigns = [];

        for (let i = 0; i < allCampaigns?.length; i++) {
            const campaign = allCampaigns[i];
            if (campaign.link && campaign.link?.url.indexOf("zoniz://") === 0) { // if campaign is MENU/RESERVATIONS/TAKEAWAY RETURN IT
                filteredCampaigns.push(campaign);
            }
        }

        return filteredCampaigns;
    }

    const chooseOrderingMethod = (method) => {
        StorageService.setItem(LOCALSTORAGE_ITEMS.ORDER_PLACE, method);
        StorageService.setItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON, "true");
        if (method === ORDER_PLACE.TABLE && !userTable) {
            //TODO useNavigate with search params
            navigateTo({
                pathname: PATH.ALL_PRODUCTS,
                search: "?readonly=true"
            });
        } else {
            navigateTo(PATH.ALL_PRODUCTS);
        }
    }

    const getCampaignsAndShopInfo = async (shopDetails) => {
        const allCampaignsResponse = await getAllCampaigns(shopDetails.name);
        const allLinkCampaigns = filterRestaurantLinkCampaigns(allCampaignsResponse).sort((a, b) => {
            if (a.link?.url === "zoniz://products") return -1;
            if (b.link?.url === "zoniz://products") return 1;

            if (a.link?.url === "zoniz://reservation") return 1;
            if (b.link?.url === "zoniz://reservation") return -1;

            return a.link.url.localeCompare(b.link.url);
        });

        const sortedCampaigns = allCampaignsResponse.sort((a, b) => {
            return -a.lastModDate.localeCompare(b.lastModDate);
        });
        setState(prev => {
            return {
                ...prev,
                allCampaigns: sortedCampaigns,
                allLinkCampaigns: allLinkCampaigns,
                shopDetails: shopDetails,
            };
        });
    }


    return (
        <>
            <Header
                headerSize={HEADER_SIZE.BIG}
                shopDetails={state.shopDetails}
                hasBackgroundImg={true}
                headerTitle={state.shopDetails?.title}
                hasModal={true}
                hasBackBtn={hasBackButton}
                returningUrl={returningUrl}
                refUrl={refUrl}
                hasProfileBtn={true}
                hasShopInfoIcon={true}
                isMainPage={true}
            />
            <div className={state.currentStyle + " modal-overlay "} onClick={(e) => closeModal()}></div>
            <div className="modal bigger">
                <div className="row">
                    <div className="modal-title"><FormattedMessage id="OrderingMethod"/></div>
                </div>

                <div className="row buttons-row">
                    <a className=" btn btn-outlined btn-md" id="tableOrdering"
                       onClick={() => chooseOrderingMethod(ORDER_PLACE.TABLE)}><FormattedMessage
                        id="TableOrdering"/></a>
                    <a className="btn btn-outlined btn-md" id="counterPickup"
                       onClick={() => chooseOrderingMethod(ORDER_PLACE.BAR)}><FormattedMessage id="CounterPickup"/></a>
                </div>
            </div>
            {state.allCampaigns && state.allCampaigns.length > 0 ?
                <section className="link-campaigns-container">
                    <div className="all-link-campaigns-list">
                        <>
                            {
                                state.allLinkCampaigns?.map((linkCampaign, linkCampaignIndex) => {
                                    return (<CampaignCard
                                        key={linkCampaignIndex + linkCampaign}
                                        campaign={linkCampaign}
                                        isLinkCampaign={true}
                                        openModal={openModal}
                                        closeModal={closeModal}
                                    />)
                                })
                            }

                            {state.allCampaigns.map((campaign, productIndex) => {
                                    if (!campaign.link || campaign.link?.url.indexOf("zoniz://") !== 0) {
                                        return (<CampaignCard
                                            key={productIndex + campaign}
                                            campaign={campaign}
                                            isLinkCampaign={campaign.link ? true : false}
                                            openModal={openModal}
                                            closeModal={closeModal}
                                        />)
                                    }
                                }
                            )
                            }
                        </>
                    </div>
                </section>
                : null}
        </>

    );
}

export default Main;
